var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWsOrdersFooterDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Home_-disabled",
    "data-name": "Home -disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18252",
    "data-name": "Rectangle 18252",
    width: 24,
    height: 24,
    fill: "#97abb8",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-pin-note-2891250",
    transform: "translate(-98.942 3.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38593",
    "data-name": "Path 38593",
    d: "M118.941,133.411a1.664,1.664,0,0,0-.469-1.161,1.579,1.579,0,0,0-1.131-.481h-4.267a.531.531,0,0,0-.462.274.56.56,0,0,0,0,.547.531.531,0,0,0,.462.274h4.267a.526.526,0,0,1,.377.16.554.554,0,0,1,.156.387v7.115h-2.667a1.58,1.58,0,0,0-1.131.481,1.664,1.664,0,0,0-.469,1.161v2.737h-9.067a.526.526,0,0,1-.377-.16.555.555,0,0,1-.156-.387V133.411a.554.554,0,0,1,.156-.387.526.526,0,0,1,.377-.16h4.267a.531.531,0,0,0,.462-.274.56.56,0,0,0,0-.547.531.531,0,0,0-.462-.274h-4.267a1.579,1.579,0,0,0-1.131.481,1.664,1.664,0,0,0-.469,1.161v10.947a1.664,1.664,0,0,0,.469,1.161,1.58,1.58,0,0,0,1.131.481h9.6a.534.534,0,0,0,.378-.161l4.267-4.379h0a.563.563,0,0,0,.156-.386Zm-3.733,8.21h1.912l-2.446,2.51v-1.963a.555.555,0,0,1,.156-.387.526.526,0,0,1,.377-.16Z",
    transform: "translate(0 -128.203)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38594",
    "data-name": "Path 38594",
    d: "M301.528,2.539V4.977a.47.47,0,1,0,.941,0V2.539a1.411,1.411,0,1,0-.941,0Zm.47-1.8a.47.47,0,1,1-.333.138A.47.47,0,0,1,302,.744Z",
    transform: "translate(-191.057)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38595",
    "data-name": "Path 38595",
    d: "M201.77,230.59h10.355v.941H201.77Z",
    transform: "translate(-96.006 -223.326)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38596",
    "data-name": "Path 38596",
    d: "M201.77,329.41h10.355v.941H201.77Z",
    transform: "translate(-96.006 -318.949)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38597",
    "data-name": "Path 38597",
    d: "M201.77,428.23h5.645v.941H201.77Z",
    transform: "translate(-95.377 -414.572)",
    fill: "#97abb8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsOrdersFooterDisabled);
export default __webpack_public_path__ + "static/media/wsOrdersFooterDisabled.ae3eaf97dbca22654ee90ea0078c0a5c.svg";
export { ForwardRef as ReactComponent };